import { Close } from "@material-ui/icons";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";

const Modal = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "sm",
  fullScreen,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      fullScreen={fullScreen}>
      <DialogTitle
        position="relative"
        sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", py: 1.5 }}>
        {title}
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            top: "50%",
            right: "10px",
            transform: "translateY(-50%)",
          }}
          onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: "20px !important" }}>{children}</DialogContent>
      {actions && (
        <DialogActions sx={{ mx: 2, mb: 2 }}>{actions}</DialogActions>
      )}
    </Dialog>
  );
};

export default Modal;
